<cdp-tenant-switcher
    *ngIf="isGlobalAdmin"
    [isInDropdown]="false"
    (tenantSelected)="onTenantSelected()"
></cdp-tenant-switcher>
